// extracted by mini-css-extract-plugin
module.exports = {"editBox":"textInput_editBox__3MO6k","markEdited":"textInput_markEdited__29fyC","markError":"textInput_markError__1v-b4"};